var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      "data-clazz": _vm.model.clazz
    }
  }, [_c("div", {
    staticClass: "panelTitle"
  }, [_vm._v(_vm._s(_vm.i18n["sequenceFlow"]))]), _c("div", {
    staticClass: "panelBody"
  }, [_c("DefaultDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["sequenceFlow.expression"]) + "：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      type: "textarea",
      rows: 4,
      disabled: _vm.readOnly,
      value: _vm.model.conditionExpression
    },
    on: {
      input: function input(value) {
        _vm.onChange("conditionExpression", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["sequenceFlow.seq"]) + "：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      value: _vm.model.seq
    },
    on: {
      input: function input(value) {
        _vm.onChange("seq", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("el-checkbox", {
    attrs: {
      disabled: _vm.readOnly,
      value: !!_vm.model.reverse
    },
    on: {
      change: function change(value) {
        return _vm.onChange("reverse", value);
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n["sequenceFlow.reverse"]))])], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };